/**
 * Cluster Variants
 *
 * CVA variants for the Cluster component.
 * Exported separately to comply with React Fast Refresh requirements.
 *
 * @see Cluster.tsx for component implementation
 */

import {cva} from 'class-variance-authority';

export const clusterVariants = cva("flex flex-wrap", {
  variants: {
    /**
     * Gap between items using Tailwind spacing scale
     * Named: xs=8px, sm=12px, md=16px, lg=24px, xl=32px
     * Numeric: 0-12 map to gap-0 through gap-12
     */
    gap: {
      // Numeric scale
      0: "gap-0",
      1: "gap-1",
      2: "gap-2",
      3: "gap-3",
      4: "gap-4",
      5: "gap-5",
      6: "gap-6",
      8: "gap-8",
      10: "gap-10",
      12: "gap-12",
      // Named scale
      xs: "gap-2",
      sm: "gap-3",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8",
    },
    /**
     * Vertical alignment of items (cross-axis)
     */
    align: {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch",
      baseline: "items-baseline",
    },
    /**
     * Horizontal distribution of items (main-axis)
     */
    justify: {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
      around: "justify-around",
      evenly: "justify-evenly",
    },
    /**
     * Whether to wrap items or keep on single line
     */
    wrap: {
      wrap: "flex-wrap",
      nowrap: "flex-nowrap",
      reverse: "flex-wrap-reverse",
    },
    /**
     * Whether the cluster should fill its container width
     */
    fullWidth: {
      true: "w-full",
      false: "",
    },
  },
  defaultVariants: {
    gap: "sm",
    align: "center",
    justify: "start",
    wrap: "wrap",
    fullWidth: false,
  },
});
